/* eslint-disable max-len */
import React, { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { animateScroll } from 'react-scroll'
import { HandleAddSlotFrame, SlotsModuleChildProps, usePragmaticDGAInfo } from '@bcraft-frontend-lib/slots'
import block from 'bem-cn'

import { useSlots } from 'modules/SlotsRoot/redefinitions/hooks'
import { SlotPlace } from 'modules/SlotsRoot/redefinitions/types'

import { selectLocaleDict } from 'features/locale/selectors'

import { Spinner } from 'components/Spinner'

import { AllSlotsList } from './AllSlotsList/AllSlotsList'

import './SlotsLayoutContent.scss'

const FilterBlock = React.lazy(() => import('components/slots/FilterBlock/FilterBlock'))

type SlotsLayoutContentProps = SlotsModuleChildProps<SlotPlace> & {
  modal?: boolean
  addFrame?: HandleAddSlotFrame
}

const b = block('slots-layout-content')

const SlotsLayoutContent: React.FC<SlotsLayoutContentProps> = ({ place, filters, modal, addFrame }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).slots

  const isLiveCasinoPlace = place === 'live-casino'

  const {
    _slots: { list: allSlots, isLoading },
    _categories: { list: categories },
    _providers: { list: providers },
  } = useSlots({ place, withoutRequests: false, filters })

  const { getGameInfo } = usePragmaticDGAInfo({
    slots: allSlots,
    needConnection: isLiveCasinoPlace,
  })

  useEffect(() => {
    animateScroll.scrollToTop()
  }, [])

  return (
    <div className={b({ modal })}>
      <Spinner isLoading={isLoading} />

      <FilterBlock
        locale={locale}
        providers={providers}
        categories={categories}
        filters={filters}
      />

      <div className={b('wrapper')}>
        <div className={b('container')}>
          <AllSlotsList
            modal={modal}
            addFrame={addFrame}
            getGameInfo={isLiveCasinoPlace ? getGameInfo : undefined}
            slots={allSlots}
            filters={filters}
          />
        </div>
      </div>
    </div>
  )
}

export default SlotsLayoutContent
